import type { IStorage, IStorageOptions } from './drivers';
import {
  CookieStorage,
  InMemoryStorage,
  LocalStorage,
  SessionStorage,
} from './drivers';

export type IStorageLocation = 'memory' | 'local' | 'session' | 'cookie';

const storageLocationBuilders: Record<IStorageLocation, () => IStorage> = {
  memory: (options?: IStorageOptions) => new InMemoryStorage(options),
  local: (options?: IStorageOptions) => new LocalStorage(options),
  session: (options?: IStorageOptions) => new SessionStorage(options),
  cookie: (options?: IStorageOptions) => new CookieStorage(options),
};

export const storageFactory = (
  location: IStorageLocation,
): ((options?: IStorageOptions) => IStorage) =>
  storageLocationBuilders[location];
